// import React, { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios, { } from 'axios';
// import { decodeJwt } from 'jose';
// import { OauthRedirectHandlerProps } from './OauthRedirectHandlerProps';
// import AxiosInterceptor from './AxiosInterceptor';
// import { useAppNavigate,  } from './useNavigateHook'; // Ajoutez ces imports
// import { logout } from '../../../../vitrine/services/Apivitrine';

// // Définition de l'interface pour la réponse de l'API lors de l'obtention des tokens.
// interface TokenResponse {
//   access_token: string; // Token d'accès.
//   refresh_token: string; // Token de rafraîchissement.
//   id_token: string; // Token d'identité.
//   expires_in: number; // Durée de validité du token d'accès.
// }

// // Définition de l'interface pour le token décodé (informations contenues dans le token).
// interface DecodedToken {
//   exp: number; // Date d'expiration du token (en secondes depuis l'époque Unix).
//   [key: string]: any; // Permet d'ajouter d'autres propriétés dynamiquement.
// }

// // Composant OauthRedirectHandler : gère la redirection après l'authentification OAuth.
// const OauthRedirectHandler: React.FC<OauthRedirectHandlerProps> = ({
//   redirectPath = '/HomeAdmin', // Chemin de redirection par défaut.
// }) => {
//   const navigate = useNavigate(); // Hook pour la navigation.
//   useAppNavigate(); // Initialise useNavigateHook

//   useEffect(() => {
//     // Fonction pour gérer le retour de l'authentification OAuth.
//     const handleOauthCallback = async () => {
//       try {
//         // Récupération du code d'autorisation depuis les paramètres de l'URL.
//         const urlParams = new URLSearchParams(window.location.search);
//         const code = urlParams.get('code');

//         // Vérification de la présence du code d'autorisation.
//         if (!code) {
//           throw new Error("Aucun code d'autorisation trouvé");
//         }

//         // Récupération du code verifier depuis le stockage local.
//         const codeVerifier = localStorage.getItem('code_verifier');
//         if (!codeVerifier) {
//           throw new Error('Code verifier non trouvé');
//         }

//         // Récupération des points de terminaison et de l'URI de redirection depuis les variables d'environnement.
//         const tokenEndpoint = import.meta.env.VITE_REDIRECT_Otenti;
//         const redirectUri = import.meta.env.VITE_REDIRECT_URI;

//         // Requête POST pour obtenir les tokens d'accès, de rafraîchissement et d'identité.
//         const response = await axios.get<TokenResponse>(
//           `https://192.168.0.14:5000/auth/callback?code=${code}`,
//           // {
//           //   code,
//           //   code_verifier: codeVerifier,
//           //   grant_type: 'authorization_code',
//           //   client_id: 'AdminOtentiCLient',
//           //   client_secret: 'Otenti-Secret',
//           //   redirect_uri: redirectUri,
//           // },
//           // {
//           //   headers: {
//           //     'Content-Type': 'application/x-www-form-urlencoded',
//           //   },
//           // }
//         );

//         // const response = await axios.post<TokenResponse>(
//         //   `${tokenEndpoint}/connect/token`,
//         //   {
//         //     code,
//         //     code_verifier: codeVerifier,
//         //     grant_type: 'authorization_code',
//         //     client_id: 'AdminOtentiCLient',
//         //     client_secret: 'Otenti-Secret',
//         //     redirect_uri: redirectUri,
//         //   },
//         //   {
//         //     headers: {
//         //       'Content-Type': 'application/x-www-form-urlencoded',
//         //     },
//         //   }
//         // );

//         // Stockage des tokens dans le stockage local.
//         // localStorage.setItem('access_token', response.data.access_token);
//         // localStorage.setItem('refresh_token', response.data.refresh_token);
//         // localStorage.setItem('id_token', response.data.id_token);

//         // Décodage du token d'identité pour récupérer l'ID de l'entreprise.
//         // const decodedIdToken = decodeJwt(response.data.id_token) as DecodedToken;
//         // const companyId = decodedIdToken['companyId'];
//         // const email= decodedIdToken['email'];
//         // localStorage.setItem('company', companyId.toString());
//         // localStorage.setItem('email', email);
//         // localStorage.setItem('email', email.toString());


//         // Redirection vers le chemin spécifié.
//         navigate(redirectPath);
//       } catch (error) {
//         // Gestion des erreurs lors de l'authentification.
//         console.error('Échec de l\'authentification OAuth:', error);
//       }
//     };

//     // Appel des fonctions d'authentification et de configuration de l'intercepteur.
//     handleOauthCallback();
//   }, [navigate, redirectPath]);

//   // Rendu du composant (message d'attente pendant l'authentification).
//   return (
//     <div>
//        {/* <AxiosInterceptor  /> */}
//        <AxiosInterceptor logout={logout} />
       
//       <div className="flex justify-center items-center h-screen">
//         <div className="text-center">
//           <p>Authentication in progress...</p>
//           <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-blue-500 mx-auto mt-4"></div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OauthRedirectHandler;

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios, { } from 'axios';
import { decodeJwt } from 'jose';
import { OauthRedirectHandlerProps } from './OauthRedirectHandlerProps';
import AxiosInterceptor from './AxiosInterceptor';
import { useAppNavigate,  } from './useNavigateHook'; // Ajoutez ces imports
import { logout } from '../../../../vitrine/services/Apivitrine';

// Définition de l'interface pour la réponse de l'API lors de l'obtention des tokens.
interface TokenResponse {
  access_token: string; // Token d'accès.
  refresh_token: string; // Token de rafraîchissement.
  id_token: string; // Token d'identité.
  expires_in: number; // Durée de validité du token d'accès.
}

// Définition de l'interface pour le token décodé (informations contenues dans le token).
interface DecodedToken {
  exp: number; // Date d'expiration du token (en secondes depuis l'époque Unix).
  [key: string]: any; // Permet d'ajouter d'autres propriétés dynamiquement.
}

// Composant OauthRedirectHandler : gère la redirection après l'authentification OAuth.
const OauthRedirectHandler: React.FC<OauthRedirectHandlerProps> = ({
  redirectPath = '/HomeAdmin', // Chemin de redirection par défaut.
}) => {
  const navigate = useNavigate(); // Hook pour la navigation.
  useAppNavigate(); // Initialise useNavigateHook

  useEffect(() => {
    // Fonction pour gérer le retour de l'authentification OAuth.
    const handleOauthCallback = async () => {
      try {
        // Récupération du code d'autorisation depuis les paramètres de l'URL.
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');

        // Vérification de la présence du code d'autorisation.
        if (!code) {
          throw new Error("Aucun code d'autorisation trouvé");
        }

        // Récupération du code verifier depuis le stockage local.
        const codeVerifier = localStorage.getItem('code_verifier');
        if (!codeVerifier) {
          throw new Error('Code verifier non trouvé');
        }

        // Récupération des points de terminaison et de l'URI de redirection depuis les variables d'environnement.
        const tokenEndpoint = import.meta.env.VITE_REDIRECT_Otenti;
        const redirectUri = import.meta.env.VITE_REDIRECT_URI;

        // Requête POST pour obtenir les tokens d'accès, de rafraîchissement et d'identité.
        const response = await axios.post<TokenResponse>(
          `${tokenEndpoint}/connect/token`,
          {
            code,
            code_verifier: codeVerifier,
            grant_type: 'authorization_code',
            client_id: 'AdminOtentiCLient',
            client_secret: 'Otenti-Secret',
            redirect_uri: redirectUri,
          },
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          }
        );

        // Stockage des tokens dans le stockage local.
        localStorage.setItem('access_token', response.data.access_token);
        localStorage.setItem('refresh_token', response.data.refresh_token);
        localStorage.setItem('id_token', response.data.id_token);

        // Décodage du token d'identité pour récupérer l'ID de l'entreprise.
        const decodedIdToken = decodeJwt(response.data.id_token) as DecodedToken;
        const companyId = decodedIdToken['companyId'];
        // const email= decodedIdToken['email'];
        localStorage.setItem('company', companyId.toString());
        // localStorage.setItem('email', email);
        // localStorage.setItem('email', email.toString());


        // Redirection vers le chemin spécifié.
        navigate(redirectPath);
      } catch (error) {
        // Gestion des erreurs lors de l'authentification.
        console.error('Échec de l\'authentification OAuth:', error);
      }
    };

    // Appel des fonctions d'authentification et de configuration de l'intercepteur.
    handleOauthCallback();
  }, [navigate, redirectPath]);

  // Rendu du composant (message d'attente pendant l'authentification).
  return (
    <div>
       {/* <AxiosInterceptor  /> */}
       <AxiosInterceptor logout={logout} />
       
      <div className="flex justify-center items-center h-screen">
        <div className="text-center">
          <p>Authentication in progress...</p>
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-blue-500 mx-auto mt-4"></div>
        </div>
      </div>
    </div>
  );
};

export default OauthRedirectHandler;


